<div
  #wrapper
  class="marquee-wrapper"
  (mouseenter)="pauseOnHover ? pause() : null"
  (mouseleave)="pauseOnHover ? resume() : null">
  <div class="marquee-layer">
    <div #aEl class="marquee-item"></div>
    <div #bEl class="marquee-item" aria-hidden="true"></div>

    <div #pool class="marquee-pool" aria-hidden="true"></div>
  </div>

  <div #source class="marquee-source">
    <ng-content></ng-content>
  </div>
</div>
